import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { Modal, Button, Glyphicon } from 'react-bootstrap';
import Dropzone from 'react-dropzone';
import { post } from 'axios';
import AppConstant, { imageConstants } from '../../../constants/app';
import browserImageSize from 'browser-image-size';
import AvatarEditor from 'react-avatar-editor';

class ImageModal extends PureComponent {
  static propTypes = {
    isActive: PropTypes.bool,
    onClose: PropTypes.func
  };

  state = {
    isImageLoaded: false,
    image: null,
    file: null,
    scale: 1,
  };

  handleScale = event => {
    this.setState({
      scale: event.target.value,
    })
  }

  onPreviewDrop = file => {
    this.setState({
      isImageLoaded: true,
      file: file[0]
    });
  };

  deleteImage = () => {
    this.setState({
      isImageLoaded: false,
      file: [],
      imageError: '',
      scale: 1,
    });
  };

  isValidImage = () => {
    if (this.state.file) {
      return browserImageSize(this.state.file).then(dimensions => {
        if (
          dimensions.height > imageConstants.height ||
          dimensions.width > imageConstants.width
        ) {
          this.setState({
            imageError: `Incorrect dimensions (max height: ${
              imageConstants.height
            }, max width: ${imageConstants.width})`
          });

          return false;
        }

        if (this.state.file.size > imageConstants.size) {
          this.setState({
            imageError: `Incorrect size (max size: ${imageConstants.size /
              1000000}MB)`
          });
          return false;
        }

        return true;
      });
    }

    this.setState({ imageError: 'Invalid image' });

    return false;
  };

  onFormSubmit = async e => {
    const { onClose, onFetchBackground } = this.props;
    e.preventDefault();

    this.fileUpload()
      .then(() => {
        onClose();
        this.deleteImage();
        setTimeout(() => {
          onFetchBackground();
        }, 1000);
      })
      .catch(err => {
        console.log('err: ', err);
      });
  };

  fileUpload = () => {
    return new Promise((resolve, reject) => {
      if (this.editor) {
        const imageCroppedBase64 = this.editor.getImage().toDataURL();

        fetch(imageCroppedBase64)
          .then(res => res.blob())
          .then(blob => {
            const myNewFile = new File([blob], 'blobname', { type: blob.type });
            const token = localStorage.getItem('token');
            const url = `${
              AppConstant.API_URL
            }/background?access_token=${token}`;
            const formData = new FormData();
            formData.append('file', myNewFile);
            const config = {
              headers: {
                'content-type': 'multipart/form-data'
              }
            };

            return post(url, formData, config).then(resolve());
          });
      } else {
        return reject();
      }
    });
  };

  onChange = e => {
    this.setState({ file: e.target.files[0] });
  };

  setEditorRef = editor => (this.editor = editor);

  render() {
    const { isImageLoaded, file, imageError } = this.state;
    const { isActive, onClose } = this.props;

    return (
      <Modal show={isActive} onHide={onClose}>
        <form onSubmit={this.onFormSubmit}>
          <Modal.Header>
            <Modal.Title>Edit Background Image</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="image-modal-container">
              <div className="image-modal-content">
                {isImageLoaded ? (
                  <div className="image-container">
                    {file && (
                      <AvatarEditor
                        ref={this.setEditorRef}
                        image={file}
                        width={450}
                        height={250}
                        border={0}
                        scale={this.state.scale}
                        rotate={0}
                      />
                    )}
                    <Button
                      onClick={this.deleteImage}
                      className="close-btn-dropzone"
                    >
                      <Glyphicon glyph="remove-circle" />
                    </Button>
                    <br />
                    <label>Zoom</label>
                    <input
                      type="range"
                      min="1"
                      max="3"
                      step="0.1"
                      defaultValue={this.state.scale}
                      onChange={e => {
                        this.handleScale(e);
                      }}
                    />
                  </div>
                ) : (
                  <div>
                    <Dropzone
                      className="dropzone"
                      accept="image/*"
                      onDrop={this.onPreviewDrop}
                      multiple={false}
                    >
                      <p>Drag and drop file here</p>
                      <p>or</p>
                      <div className="input-upload">Browse file</div>
                    </Dropzone>
                  </div>
                )}
                <p className="error-message">{imageError}</p>
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button
              type="button"
              className="cancel-btn"
              onClick={e => {
                onClose();
                this.deleteImage();
              }}
            >
              Cancel
            </Button>
            <Button type="submit" className="accept-btn">
              Accept
            </Button>
          </Modal.Footer>
        </form>
      </Modal>
    );
  }
}

export default ImageModal;



// WEBPACK FOOTER //
// ./src/app/screens/general/imageModal.js